import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { useWindowDimensions } from '@Iot-Bee/standard-web-library';
import { fills, insideOutsideFills } from './themes';
import { BeatLoader } from 'react-spinners';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { getPieChartOptions } from './chartOptions';
import { ChartTheme, DonutData } from './interfaces';

interface DonutChartProps {
  theme: ChartTheme;
  donutData: DonutData[];
  isLoading: boolean;
}
export const DonutChart = ({ theme, donutData, isLoading }: DonutChartProps) => {
  const container = useRef<HighchartsReact.RefObject>(null);
  const { screenwidth } = useWindowDimensions();

  const myTheme = {
    baseTheme: theme.baseTheme,
    palette: {
      fills: theme.mode === 'total' ? insideOutsideFills : fills,
      strokes: theme.mode === 'total' ? insideOutsideFills : fills,
    },
  };

  return (
    <Box
      sx={{
        width: screenwidth > 768 ? '33.333%' : '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: screenwidth > 768 ? '100%' : '330px',
        }}
      >
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              height: '100%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1,
            }}
          >
            <BeatLoader color={myTheme.palette.fills[0]} />
          </Box>
        )}
        <HighchartsReact
          highcharts={Highcharts}
          options={getPieChartOptions(
            donutData,
            theme,
            donutData.reduce((acc, item) => acc + item.y, 0)
          )}
          ref={container}
          style={{
            width: '100%',
            height: screenwidth > 768 ? '100%' : '330px',
          }}
        />
      </Box>
    </Box>
  );
};
